<template>
  <div class="tw-flex tw-justify-center">
    <div class="tw-flex tw-flex-col tw-overflow-x-auto tw-mt-8">
      <WdsStack justify-space-between class="tw-mb-7">
        <WdsHeading as="h1" type="display">
          {{ $t('Authorisation Request') }}
        </WdsHeading>
      </WdsStack>

      <WdsStack direction-column>
        <WdsText>
          <strong>{{ client.name }}</strong>
          {{ $t('is requesting permission to access your account.') }}
        </WdsText>
      </WdsStack>

      <WdsStack v-if="scopes.length > 0" direction-column class="tw-mt-4">
        <WdsText>
          <strong>{{ $t('This application will be able to:') }}</strong>
        </WdsText>

        <WdsStack>
          <ul v-for="scope in scopes" :key="scope" class="tw-mt-3 tw-list-disc tw-list-inside">
            <li>{{ scope }}</li>
          </ul>
        </WdsStack>
      </WdsStack>

      <WdsStack direction-row justify-center class="tw-mt-4 tw-space-x-6">
        <BaseHtmlForm method="POST" action="/oauth/authorize">
          <input type="hidden" name="state" :value="state" />
          <input type="hidden" name="client_id" :value="client.id" />
          <input type="hidden" name="auth_token" :value="authToken" />
          <WdsButton success data-test="authorise" type="submit">
            {{ $t('Authorise') }}
          </WdsButton>
        </BaseHtmlForm>

        <BaseHtmlForm method="DELETE" action="/oauth/authorize">
          <input type="hidden" name="state" :value="state" />
          <input type="hidden" name="client_id" :value="client.id" />
          <input type="hidden" name="auth_token" :value="authToken" />
          <WdsButton tertiary data-test="deny" type="submit">
            {{ $t('Cancel') }}
          </WdsButton>
        </BaseHtmlForm>
      </WdsStack>
    </div>
  </div>
</template>

<script setup lang="ts">
import { WdsButton, WdsHeading, WdsStack, WdsText } from '@worksome/wds-components'
import BaseHtmlForm from '@/components/BaseHtmlForm.vue'
import { $t } from '@/composables/translation'

interface Client {
  id: string
  name: string
}

defineProps<{
  authToken: string
  client: Client
  scopes: Array<string>
  state: string
}>()
</script>
